import { MediaDisplay } from "@package/ui-wall-components";
import { type PostProps } from "../../utils/post-props";

export function PostStandard({ asset }: PostProps) {
  return <MediaDisplay id={asset?.media ?? undefined} />;
}
